module.exports = "<div class=\"container mt-3\">\n  <div class=\"row justify-content-center\">\n    <div class=\"col-sm-4 col-lg-3\">\n      <img class=\"img-fluid rounded\" src=\"assets/images/{{artist.shortname}}.jpg\" alt=\"{{artist.name}} photo\">\n    </div>\n    <div class=\"col-sm-8 col-lg-4\">\n      <h2 class=\"mt-3 mt-sm-0 mb-0\">{{artist.name}}</h2>\n      <h4 class=\"mt-0\">{{artist.reknown}}</h4>\n      <p>{{artist.bio}}</p>\n    </div>\n  </div>\n</div><!--artistdetails-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/artist-details/artist-details.component.html
// module id = ./src/app/artist-details/artist-details.component.html
// module chunks = main